import React from "react";
import { Box } from "@mui/material";

// Standard page wrapper: consistent max-width and padding on every page.
export default function PageContainer({ children, maxWidth = 1200 }) {
  return (
    <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 3, md: 4 } }}>
      <Box sx={{ maxWidth, mx: "auto" }}>{children}</Box>
    </Box>
  );
}
